// Library version, stamped on every report so servers can tell which
// detection logic produced it. Must match package.json (a test checks).
export const VERSION = "0.1.0";
